import React from 'react';
import '../styles/Research.css'; // reuse styles

function Education() {
  return (
    <div className="research-page">
      <div className="container">
        <section className="research-category">
          <h2>Education</h2>
          <p>
            Mechanics plays a central role in the simulation of material and structural response. Hence a substantial portion of our activities is focused on the development of computational tools that accelerate delivery, learning, and implementation of mechanics principles through simulation, visualization, and animation. The previously developed Mathematica-based educational modules for second-year Statics and Strength of Materials courses resident on <a href="https://pinderagroup.github.io/index.html" target="_blank" rel="noopener noreferrer">https://pinderagroup.github.io/index.html</a> are presently being re-configured to enable interactive use on the EMC website. To accomplish this, we engage undergraduate students as summer interns or during the academic year. This experience supplements and expands on the fundamental mechanics courses that are required for graduation.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Education;
